export default {
  namespaced: true,
  state: {
    intents: [],
    asyncIntentsDone: true
  },
  mutations: {
    setIntents(state, intents) {
      state.intents = intents;
    },
    setRemoveIntentsIdx(state, idx) {
      state.intents = state.intents.splice(idx, 1);
    },
    setRemoveIntentsAll(state) {
      state.intents = [];
      state.asyncIntentsDone = true;
    },
    setAsyncIntentDone(state, isDone) {
      state.asyncIntentsDone = isDone;
    }
  },
  actions: {}
};
